import React, {Component} from 'react';
import {Modal, ModalHeader} from 'reactstrap';
import {AddAdAccountForm} from "./AddAdAccountForm";
import {SheetLogo} from "../../logos/SheetLogo";

export class AddAdAccountModal extends Component {
    constructor(props) {
        super(props);
        this.state = {
            modal: false,
        };

        this.toggle = this.toggle.bind(this);
        this.afterSuccessfulSubmit = this.afterSuccessfulSubmit.bind(this);
    }

    toggle() {
        this.setState({
            modal: !this.state.modal
        });
    }

    afterSuccessfulSubmit(newSheetAdAccountData) {
        this.toggle();
        this.props.afterSuccessfulSubmit(newSheetAdAccountData);
    }

    render() {
        return (
            <Modal isOpen={this.state.modal} toggle={this.toggle} className={this.props.className} backdrop="static">
                <ModalHeader toggle={this.toggle}><SheetLogo/>&nbsp;Importar métricas desde un archivo CSV online</ModalHeader>
                <AddAdAccountForm afterSuccessfulSubmit={this.afterSuccessfulSubmit}
                                  clientId={this.props.clientId}
                                  clientName={this.props.clientName}/>
            </Modal>
        );
    }
}
